import React from 'react';

import '../../../styles/shop/shirt-colors-control.scss';

const ShirtColorsControl = props => {
  return (
    <>
      <span className="product-view__meta-label">Colors</span>
      <div className="shirt-colors__container">
        {props.colors.map(color => (
          <button
            className={`shirt-colors__option ${(props.color === color) ? 'selected' : ''}`}
            onClick={() => props.onChange(color)}
          >
            <div className={`shirt-colors__swatch shirt-colors__swatch__${color.toLowerCase().replace(' ', '-')}`}></div>
            <div className="shirt-colors__label">{color}</div>
          </button>
        ))}
      </div>
    </>
  );
}

export default ShirtColorsControl;